import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'
import type { ENTITY_KEYS } from '~/api/query/entities'

export const entities = createQueryKeys('entities', {
  entity: (entityKey: ENTITY_KEYS) => [entityKey],
})

export type EntitiesKeys = inferQueryKeys<typeof entities>
